
import Vue from "vue";
import {setTitle, resetTitle} from "@/utils/title";
import {TicketReadList} from "@/models/ticket-read-list";
import {TicketService} from "@/services/ticket-service";
import {Ticket} from "@/models/ticket";
import {Admin} from "@/models/admin";
import {AdminsService} from "@/services/admins-service";

export interface iReadList {
	tickets: {ticket:Ticket,timeFirstRead:Date}[];
}

export default Vue.extend({
	data() {
		return {
			tickets: [] as TicketReadList[],
			list: {} as { [key: number]: iReadList },
			date: new Date(),
			admins: [] as Admin[],
		};
	},
	computed: {},
	watch: {
		async date(){
			await this.fetch();
		}
	},
	methods: {
		getAdminName(id:number):string{
			let a = this.admins.filter((i) => i.id == id);
			if(a[0]){
				return a[0].name;
			}
			return "";

		},
		formatTime(date: Date){
			const d = date;
			let hours = d.getHours().toString().padStart(2, "0");
			let minutes = d.getMinutes().toString().padStart(2, "0");
			return hours + ":" + minutes;
		},
		async fetch() {
			this.list = {};
			this.tickets = await TicketService.fetchReadList(this.date);
			if (this.tickets) {
				this.tickets.map((t) => {
					if (!this.list[t.adminId]) {
						this.list[t.adminId] = {tickets: []};
					}
					this.list[t.adminId].tickets.push({ticket: t.ticket as Ticket,timeFirstRead: t.timeFirstRead});
				});
			}
		}
	},
	async created() {
		setTitle("Ticket lijst");
		await this.fetch();
		this.admins = await AdminsService.getAdmins();

	},
	destroyed() {
		resetTitle();
	},
	components: {},
});
